import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pt from './locales/pt.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import en from './locales/en.json';
import esAR from './locales/es-AR.json';
import esCL from './locales/es-CL.json';
import esCO from './locales/es-CO.json';
import esDO from './locales/es-DO.json';
import esEC from './locales/es-EC.json';
import esGT from './locales/es-GT.json';
import esMX from './locales/es-MX.json';
import esPA from './locales/es-PA.json';
import esPE from './locales/es-PE.json';
import esPY from './locales/es-PY.json';
import esSV from './locales/es-SV.json';
import esHN from './locales/es-HN.json';
import esCR from './locales/es-CR.json';
import esVE from './locales/es-VE.json';
import ptBR from './locales/pt-BR.json';
import frMA from './locales/fr-MA.json';
import enPH from './locales/en-PH.json';

const variableAmbient = process.env.REACT_APP_LANGUAGE || 'pt-BR';
const language = variableAmbient.replace('-', '');
const validateLanguagemDefault = () => {
  if ((/es/).test(language)) {
    return 'es';
  }

  if ((/fr/).test(language)) {
    return 'fr';
  }

  if ((/en/).test(language)) {
    return 'en';
  }

  return 'pt';
}
const genericLanguage = validateLanguagemDefault();

const resources = {
  pt,
  es,
  fr,
  en,
  esAR,
  esCL,
  esCO,
  esDO,
  esEC,
  esGT,
  esMX,
  esPA,
  esPE,
  esPY,
  esSV,
  esHN,
  esCR,
  esVE,
  ptBR,
  frMA,
  enPH,
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: genericLanguage,
    lng: language,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
